import { SEO } from "@/components/SEO";
import { pageSchema } from "@/lib/organization";

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy | TLC Associates LLC"
        description="Read how TLC Associates LLC handles contact-form and estimate-request information for landscaping customers in Norfolk County."
        path="/privacy"
        noindex
        schema={pageSchema("/privacy", "WebPage", "Privacy Policy | TLC Associates LLC", "Read how TLC Associates LLC handles contact-form and estimate-request information for landscaping customers in Norfolk County.")}
      />
      
      <section className="py-20 bg-[#f7f3ed] min-h-[70vh]">
        <div className="container mx-auto px-4 max-w-3xl">
          <div className="bg-white p-10 md:p-12 rounded-2xl shadow-sm border border-gray-100">
            <h1 className="text-3xl md:text-4xl text-[#1a3a1a] mb-8 font-serif font-bold">Privacy Policy</h1>
            
            <div className="prose prose-lg text-gray-700">
              <p className="mb-6">
                Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>
              
              <p className="mb-6">
                TLC Associates LLC ("we", "our", or "us") operates the tlcassociates.llc website. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website.
              </p>

              <h2 className="text-2xl text-[#1a3a1a] mt-8 mb-4 font-semibold">Information We Collect</h2>
              <p className="mb-6">
                We only collect information that you voluntarily provide to us when you fill out our contact form or call us to request an estimate. This may include your:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Name</li>
                <li>Phone number</li>
                <li>Email address</li>
                <li>Property address or town</li>
                <li>Details about your landscaping project</li>
              </ul>

              <h2 className="text-2xl text-[#1a3a1a] mt-8 mb-4 font-semibold">How We Use Your Information</h2>
              <p className="mb-6">
                We use the information we collect solely for the purpose of communicating with you about your landscaping needs, providing estimates, and scheduling services. We do not sell, rent, or lease your personal data to third parties.
              </p>

              <h2 className="text-2xl text-[#1a3a1a] mt-8 mb-4 font-semibold">Data Security</h2>
              <p className="mb-6">
                We implement reasonable security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
              </p>

              <h2 className="text-2xl text-[#1a3a1a] mt-8 mb-4 font-semibold">Contact Us</h2>
              <p className="mb-6">
                If you have questions about this Privacy Policy, please contact us at:
                <br /><br />
                TLC Associates LLC<br />
                149 West Central Street<br />
                Franklin, MA 02038<br />
                Phone: 508-505-1539
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}